export default{
    // Default texts
    "general.signal": 'Signal',
    "general.view": 'View',

    // ...
    // Traducir al español llegado el momento
};